import { marked } from 'marked'
import DOMPurify from 'dompurify'

/**
 * Slugify a heading text to a stable anchor id.
 * Mirrors the same algorithm used by the backend's heading parser so scrollspy
 * anchors match the IDs in DocArticleResource.headings.
 */
export function slugifyHeading(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
}

/**
 * Render Markdown to sanitised HTML.
 * h2 and h3 elements receive an `id` attribute derived from their text so the
 * DocsScrollspy IntersectionObserver can target them by anchor id.
 */
export function renderMarkdown(raw: string): string {
  const renderer = new marked.Renderer()

  // Emit stable heading ids on h2/h3 so scrollspy anchors match
  renderer.heading = ({
    text,
    depth,
  }: {
    text: string
    depth: number
    raw: string
  }): string => {
    if (depth === 2 || depth === 3) {
      const id = slugifyHeading(text)
      return `<h${depth} id="${id}">${text}</h${depth}>\n`
    }
    return `<h${depth}>${text}</h${depth}>\n`
  }

  return DOMPurify.sanitize(
    marked.parse(raw, { breaks: true, renderer }) as string,
  )
}
